export const originalTagGroupKinds = ['originalTagGroupA', 'originalTagGroupB', 'originalTagGroupC', 'originalTagGroupD', 'originalTagGroupE'] as const
